/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_ApprovedInputs */

const en_wb_sales_approved = /** @type {(inputs: Wb_Sales_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example approved. The next step would be to send the follow-up and update the account record.`)
};

const lv_wb_sales_approved = /** @type {(inputs: Wb_Sales_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piemērs apstiprināts. Nākamais solis būtu nosūtīt atgādinājumu un atjaunināt klienta ierakstu.`)
};

/**
* | output |
* | --- |
* | "Example approved. The next step would be to send the follow-up and update the account record." |
*
* @param {Wb_Sales_ApprovedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_approved = /** @type {((inputs?: Wb_Sales_ApprovedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_ApprovedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_approved(inputs)
	return en_wb_sales_approved(inputs)
});